export const SUBSCRIPTION_TYPE = {
  EMAIL: 'emailSubscribe',
  PUSH: 'pushSubscribe',
};
